import ConversationRecord from "models/view-models/conversations/conversation-record";
import { Dispatch } from "react";
import { ConversationHistoryAction } from "./conversation-history-atom-reducer";

/**
 * Adds a conversation to the history state.
 */
export const addConversation = (conversation: ConversationRecord) => {
    return (dispatch: Dispatch<ConversationHistoryAction>) => {
        dispatch({
            type: "ADD_CONVERSATION",
            conversation: conversation.removeMessages(),
        });
    };
};
